import { render, staticRenderFns } from "./EbookImageCard.vue?vue&type=template&id=24e89f4a&scoped=true"
import script from "./EbookImageCard.vue?vue&type=script&lang=js"
export * from "./EbookImageCard.vue?vue&type=script&lang=js"
import style0 from "./EbookImageCard.vue?vue&type=style&index=0&id=24e89f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e89f4a",
  null
  
)

export default component.exports